export const GET_COUNTRY_RANKINGS_LIST = "GET_COUNTRY_RANKINGS_LIST"
export const GET_COUNTRY_RANKINGS_LIST_SUCCESS = "GET_COUNTRY_RANKINGS_LIST_SUCCESS"
export const DOWN_COUNTRY_RANKINGS_EXCEL = "DOWN_COUNTRY_RANKINGS_EXCEL"
export const DOWN_COUNTRY_RANKINGS_EXCEL_SUCCESS = "DOWN_COUNTRY_RANKINGS_EXCEL_SUCCESS"
export const DOWN_COUNTRY_RANKINGS_PDF = "DOWN_COUNTRY_RANKINGS_PDF"
export const DOWN_COUNTRY_RANKINGS_PDF_SUCCESS = "DOWN_COUNTRY_RANKINGS_PDF_SUCCESS"
export const CLEAR_COUNTRY_RANKINGS_LIST = "CLEAR_COUNTRY_RANKINGS_LIST"
